module.exports = __webpack_public_path__ + "86ae4f70d8cdc213d440483402a07c80.pdf";